module.exports = __webpack_public_path__ + "static/img/banner1.469a6f2.webp";


//////////////////
// WEBPACK FOOTER
// ./static/images2/h5/banner1.webp
// module id = 7tqZ
// module chunks = 1